var map = {
	"./1.svg": 91328,
	"./10.svg": 76518,
	"./11.svg": 53472,
	"./2.svg": 82270,
	"./3.svg": 92389,
	"./4.svg": 15356,
	"./5.svg": 66299,
	"./6.svg": 96600,
	"./7.svg": 63014,
	"./8.svg": 77094,
	"./9.svg": 41245,
	"./analysis.svg": 31490,
	"./biaoxingshuju.svg": 41488,
	"./blast.svg": 75026,
	"./blast1.svg": 34117,
	"./browse.svg": 81511,
	"./deseq2.svg": 15019,
	"./download.svg": 88696,
	"./expression.svg": 87542,
	"./go.svg": 49030,
	"./home.svg": 47155,
	"./icon1.svg": 14744,
	"./icon2.svg": 88652,
	"./icon3.svg": 24714,
	"./icon4.svg": 65813,
	"./icon5.svg": 49648,
	"./icon6.svg": 52242,
	"./jiyinxin.svg": 51586,
	"./kegg.svg": 52421,
	"./language.svg": 32874,
	"./msa.svg": 86091,
	"./msaDown.svg": 25197,
	"./pathway.svg": 68908,
	"./peo.svg": 24428,
	"./search.svg": 95,
	"./sequence.svg": 12564,
	"./sequence1.svg": 32314,
	"./te.svg": 99888,
	"./tools.svg": 48734,
	"./venn.svg": 16951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51620;